export const CardData = {
    HealthInputDetailsWidget: [
      {
        icon: 'https://acko-seo-prod.ackoassets.com/_next_static/images/health/no_waiting_period.svg',
        heading: { web: 'Zero', mobile: 'Zero waiting' },
        subHeading: { web: 'Waiting period', mobile: 'period' },
      },
      {
        icon: 'https://acko-seo-prod.ackoassets.com/_next_static/images/health/treatment_covered.svg',
        heading: { web: '10,500+', mobile: '10,500+ network' },
        subHeading: { web: 'Cashless hospitals', mobile: 'hospitals' },
      },
      {
        icon: 'https://acko-seo-prod.ackoassets.com/_next_static/images/health/success_great_approved_congrats.svg',
        heading: { web: '100%', mobile: '100% bill' },
        subHeading: { web: 'Bills covered', mobile: 'amount covered' },
      },
    ],
    AbhaWidget: [
      {
        icon: 'https://acko-seo-prod.ackoassets.com/_next_static/images/Digital_Locker_Safe.png',
        heading: { web: 'Digital locker', mobile: 'Digital locker' },
        subHeading: { web: 'for health info', mobile: 'for health info' },
      },
      {
        icon: 'https://acko-seo-prod.ackoassets.com/_next_static/images/Easy_access_Files.png',
        heading: { web: 'Easy access', mobile: 'Easy access' },
        subHeading: { web: 'Anytime, anywhere', mobile: 'Anytime, anywhere' },
      },
      {
        icon: 'https://acko-seo-prod.ackoassets.com/_next_static/images/Highly_seccure_Safe.png',
        heading: { web: 'Highly secure', mobile: 'Highly secure' },
        subHeading: { web: 'and private', mobile: 'and private' },
      },
    ],
  }
